import axios from "axios";
import { clientChecklistUrlV2, ClientChecklistV2, } from "./getClientChecklistV2";
export const PatchClientChecklistPayload = ClientChecklistV2.omit({
    version: true,
    onboardingComplete: true,
});
export default async function patchClientChecklist(clientId, body, idempotencyKey, config) {
    await axios.patch(clientChecklistUrlV2(clientId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
            Version: "20241205",
            "Idempotency-key": idempotencyKey,
        },
    });
}
//# sourceMappingURL=patchClientChecklistV2.js.map